import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
// import axios from '@/services/axiosInstance';
import axiosInstance from "../helpers/Axios";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import '../css/flyers.scss';




// interface Props {
//   lightId: string;
//   lightName: string;
//   lightComment: string;
// }

// const renderIndicator = (
//   clickHandler: (e: React.MouseEvent | React.KeyboardEvent) => void,
//   isSelected: boolean,
//   index: number,
//   label: string
// ) => React.ReactNode;


type FlyerImage = {
  file: string;
  src: string;
};


const Flyers = () => {
  const [images, setImages] = useState<FlyerImage[]>([]);

  useEffect(() => {
    const loadFlyers = async () => {
      const res = await axiosInstance.get('/image');

      const flyersFolder = res.data.find(
        (folder: any) => folder.name === 'flyers'
      );

      if (flyersFolder?.files) {
        setImages(
          flyersFolder.files
            .sort()
            .map((file: string) => ({
              file,
              src: `${import.meta.env.VITE_BACKEND_URL}/images/flyers/${file}`,
            }))
        );
      }
    };

    loadFlyers();
  }, []);

  if (images.length === 0) {
    return null; // ou un loader si tu préfères
  }

  return (
    <div>
      <div className="flyers">
        <div>
          <Carousel
            infiniteLoop
            showThumbs={false}
            autoPlay={images.length > 1}
            emulateTouch
            swipeable
            useKeyboardArrows
            showStatus={false}
          // renderIndicator={renderIndicator}
          >

            {images.map((img, index) => (
              <div key={index} className="carousel-item">
                <div className="content">
                  <Link to="contact">
                    <div className="inner-content">
                      <img
                        src={img.src}
                        alt={img.file
                          .replace(/\.[^/.]+$/, '')
                          .replace(/[-_]/g, ' ')
                        }
                        loading="lazy" />
                    </div>
                  </Link>
                </div>
              </div>
            ))}

            {/* 
            <div id="grenouille" className="carousel-item">
              <div className="content">
                <Link to="contact">
                  <div className="inner-content">
                    <img id="scheduling-17983227" src="/images/creacirque.jpg" alt="grenouille" />
                  </div>
                </Link>
              </div>
            </div>
            <div id="cours" className="carousel-item">
              <div className="content">
                <Link to="contact">
                  <div className="inner-content">
                    <img id="scheduling-17983227" src="/images/flyers/cours.jpg" alt="cours" />
                  </div>
                </Link>
              </div>
            </div>
            <div id="crossfit" className="carousel-item">
              <div className="content">
                <Link to="contact">
                  <div className="inner-content">
                    <img id="scheduling-17983227" src="/images/flyers/crossfit.png" alt="crossfit" />
                  </div>
                </Link>
              </div>
            </div>
            <div id="annif" className="carousel-item">
              <div className="content">
                <Link to="contact">
                  <div className="inner-content">
                    <img id="scheduling-17983227" src="/images/flyers/annif.jpg" alt="annif" />
                  </div>
                </Link>
              </div>
            </div>
            <div id="monocycle" className="carousel-item">
              <div className="content">
                <Link to="contact">
                  <div className="inner-content">
                    <img id="scheduling-17983227" src="/images/flyers/mono.png" alt="monocycle" />
                  </div>
                </Link>
              </div>
            </div>
            <div id="general" className="carousel-item">
              <div className="content">
                <Link to="contact">
                  <div className="inner-content">
                    <img id="scheduling-17983227" src="/images/flyers/general.jpg" alt="general" />
                  </div>
                </Link>
              </div>
            </div>
            <div id="trampoline" className="carousel-item">
              <div className="content">
                <Link to="contact">
                  <div className="inner-content">
                    <img id="scheduling-17983227" src="/images/flyers/trampo.png" alt="trampoline" />
                  </div>
                </Link>
              </div>
            </div>
    //onclick="openScheduling(17983227)" */}
          </Carousel>
        </div>
      </div>

    </div>
  )
};

export default Flyers;
